import React from 'react';
import { Edit, SimpleForm } from 'react-admin';

import { CustomToolbar, Grid } from '../../components'
import DepartmentFields from './DepartmentFields'

export const DepartmentEdit = props => (
  <Edit {...props}>
    <SimpleForm toolbar={<CustomToolbar />}>
      <Grid container spacing={8}>
        <DepartmentFields />
      </Grid>
    </SimpleForm>
  </Edit>
);

export default DepartmentEdit
